import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, helpers), {}, {
  allocation: {
    boxShadow: palette.shadows.light,
    borderRadius: '2px',
    marginTop: '20px'
  },
  currentCycleTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '32px 0 24px 0'
  },
  currentCycleHint: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiSvgIcon-root': {
      marginLeft: '7px',
      '& path': {
        fill: palette.info.main
      }
    }
  },
  allocationInfo: {
    borderRadius: '2px 2px 0 0',
    padding: '24px 32px',
    backgroundColor: palette.shades[100],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [breakpointsFunc.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  allocationTitle: {
    [breakpointsFunc.breakpoints.down('md')]: {
      marginBottom: '24px'
    }
  },
  section: {
    marginTop: '32px'
  },
  mediumSection: {
    marginTop: '24px'
  },
  allocationHistoryButton: {
    marginTop: '32px'
  },
  accordion: {
    boxShadow: 'none',
    '&.Mui-expanded': {
      margin: '0'
    },
    '& .MuiAccordionSummary-root': {
      background: palette.gradients.white,
      flexDirection: 'row-reverse',
      minHeight: '84px',
      padding: '0 32px'
    },
    '& .MuiCollapse-root': {
      borderTop: "1px solid ".concat(palette.shades[300])
    }
  },
  accordionContent: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between'
  },
  title: {
    flexGrow: '1'
  },
  actions: {
    display: 'flex',
    padding: '24px 24px 24px 0',
    alignItems: 'center',
    '& .MuiButton-root': {
      width: '100%'
    }
  },
  currentActions: {
    [breakpointsFunc.breakpoints.down('md')]: {
      padding: '0px 24px 24px 24px',
      width: '100%'
    }
  },
  table: {
    boxShadow: 'none',
    '& .MuiTableRow-head': {
      borderBottom: "1px solid ".concat(palette.shades[300])
    },
    '& .MuiTableCell-root': {
      padding: '18px 16px',
      whiteSpace: 'nowrap',
      '&:first-child': {
        paddingLeft: '32px'
      },
      '&:last-child': {
        paddingRight: '32px'
      }
    },
    '& tr:last-of-type .MuiTableCell-root': {
      borderBottom: '0'
    }
  },
  utility: {
    display: 'flex',
    alignItems: 'center'
  },
  lightCell: {
    color: palette.shades[600]
  },
  utilityIcons: {
    cursor: 'default',
    '&:hover': {
      cursor: 'default'
    },
    '& .MuiSvgIcon-root + .MuiSvgIcon-root': {
      marginLeft: '10px'
    }
  },
  summary: {
    backgroundColor: palette.shades[200],
    borderTop: "1px solid ".concat(palette.shades[300]),
    padding: '18px 32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  openAllocationButton: {
    [breakpointsFunc.breakpoints.down('md')]: {
      width: '100%'
    }
  },
  noUtilitiesHint: {
    background: palette.gradients.white,
    padding: '24px 32px'
  },
  inlineTooltip: {
    padding: '0',
    marginLeft: '4px'
  },
  cellWithHint: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  }
}));
export default useStyles;